import axios from "axios";
const baseURL = import.meta.env.VITE_Backend_URL;

// Helper function to handle 401 unauthorized errors
const handleUnauthorized = () => {
  // Clear token from localStorage
  localStorage.removeItem("lsh-token");
  // Redirect to login page
  window.location.href = "/";
};
export const adminlogin = async (email, password) => {
  try {
    const response = await axios.post(`${baseURL}/api/admin/login`, {
      email,
      password,
    });
    return response;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

export const adminLogout = async () => {
  try {
    await axios.get(`${baseURL}/auth/sso/logout/redirect`);
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

export const adminsignup = async (
  firstName,
  lastName,
  businessType,
  userRole,
  email,
  password,
  permissions,
  userCountry,
  companies,
  businesses
) => {
  const token = localStorage.getItem("lsh-token");

  try {
    const response = await axios.post(
      `${baseURL}/api/admin/signup`,
      {
        firstName,
        lastName,
        businessType,
        userRole,
        email,
        password,
        permissions,
        userCountry,
        companies,
        businesses,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle 401 unauthorized error
    if (error.response?.status === 401) {
      handleUnauthorized();
      throw error;
    }
    console.error("Signup failed:", error);
    throw error;
  }
};

export const fetchusers = async (page = 1, limit = 10, search = "") => {
  const token = localStorage.getItem("lsh-token");

  if (!token) {
    //// console.log("No token found");
    return null;
  }
  try {
    const response = await axios.get(`${baseURL}/api/admin/getallusers`, {
      params: { page, limit, search },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    // Handle 401 unauthorized error
    if (error.response?.status === 401) {
      handleUnauthorized();
      return error.response;
    }
    console.error("Failed to fetch users:", error.message);
    return error.response;
  }
};
export const deleteuserdata = async (id) => {
  const token = localStorage.getItem("lsh-token");

  //// console.log(token);

  if (!token) {
    //// console.log("No token found");
    return null;
  }

  try {
    const response = await axios.delete(
      `${baseURL}/api/admin/deleteuser/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle 401 unauthorized error
    if (error.response?.status === 401) {
      handleUnauthorized();
      return error.response;
    }
    console.error("Failed to delete user:", error.message);
    return error.response;
  }
};

export const Updateuserdata = async (id, data) => {
  const token = localStorage.getItem("lsh-token");

  if (!token) {
    //// console.log("No token found");
    return null;
  }

  try {
    const response = await axios.put(
      `${baseURL}/api/admin/updateuser/${id}`,
      {
        userData: data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle 401 unauthorized error
    if (error.response?.status === 401) {
      handleUnauthorized();
      return error.response;
    }
    return error.response;
  }
};
